import PropTypes from "prop-types";
import React from "react";

const UnitSummaryIcon = props => {
  return (
    // <svg
    //   width={props.width}
    //   height={props.height}
    //   fill="none"
    //   viewBox="0 0 100 100"
    // >
    //   <rect width={props.width} height={props.height} fill={props.fill} />
    //   <path
    //     d="M30 50C30 50 62.1895 50 70 50M30 70H70M42 30C40.0474 30 30 30 30 30M80 90H20C14.5 90 10 85.5 10 80V20C10 14.5 14.5 10 20 10H80C85.5 10 90 14.5 90 20V80C90 85.5 85.5 90 80 90Z"
    //     stroke="white"
    //     stroke-width="7.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    // </svg>

    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 100 100"
      fill="none"
    >
      <rect width={props.width} height={props.height} fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 6.25C14.6447 6.25 6.25 14.6447 6.25 25V75C6.25 85.3553 14.6447 93.75 25 93.75H75C85.3553 93.75 93.75 85.3553 93.75 75V25C93.75 14.6447 85.3553 6.25 75 6.25H25ZM28.125 28.125C26.3991 28.125 25 29.5241 25 31.25C25 32.9759 26.3991 34.375 28.125 34.375H40.625C42.3509 34.375 43.75 32.9759 43.75 31.25C43.75 29.5241 42.3509 28.125 40.625 28.125H28.125ZM28.125 46.875C26.3991 46.875 25 48.2741 25 50C25 51.7259 26.3991 53.125 28.125 53.125H71.875C73.6009 53.125 75 51.7259 75 50C75 48.2741 73.6009 46.875 71.875 46.875H28.125ZM25 68.75C25 67.0241 26.3991 65.625 28.125 65.625H71.875C73.6009 65.625 75 67.0241 75 68.75C75 70.4759 73.6009 71.875 71.875 71.875H28.125C26.3991 71.875 25 70.4759 25 68.75Z"
        fill={props.fill}
      />
    </svg>
  );
};

UnitSummaryIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
};

UnitSummaryIcon.defaultProps = {
  height: 24,
  width: 24,
};

export default UnitSummaryIcon;
